<template>
  <div class="cleaning-stats-container">
    <el-card class="box-card">
      <div class="toolbar">
        <el-button-group>
          <el-button size="mini" :type="preset==='today'?'primary':'default'" @click="setPreset('today')">本日</el-button>
          <el-button size="mini" :type="preset==='week'?'primary':'default'" @click="setPreset('week')">本周</el-button>
          <el-button size="mini" :type="preset==='month'?'primary':'default'" @click="setPreset('month')">本月</el-button>
          <el-button size="mini" :type="preset==='year'?'primary':'default'" @click="setPreset('year')">本年</el-button>
          <el-button size="mini" :type="preset==='custom'?'primary':'default'" @click="setPreset('custom')">自定义</el-button>
        </el-button-group>
        <el-date-picker v-model="dateRange[0]" type="datetime" size="mini" placeholder="开始日期" style="margin-left:10px;width:180px" :disabled="preset!=='custom'" />
        <span style="margin:0 6px;color:#909399">至</span>
        <el-date-picker v-model="dateRange[1]" type="datetime" size="mini" placeholder="结束日期" style="width:180px" :disabled="preset!=='custom'" />
        <el-select v-model="region" size="mini" placeholder="请选择区域" style="margin-left:10px;width:120px">
          <el-option v-for="o in regionOptions" :key="o.value" :label="o.label" :value="o.value" />
        </el-select>
        <el-select v-model="containerType" size="mini" placeholder="容器" style="margin-left:10px;width:120px">
          <el-option v-for="o in containerOptions" :key="o.value" :label="o.label" :value="o.value" />
        </el-select>
        <el-select v-model="operator" size="mini" placeholder="清运人" style="margin-left:10px;width:120px">
          <el-option v-for="o in operatorOptions" :key="o.value" :label="o.label" :value="o.value" />
        </el-select>
        <el-button size="mini" type="primary" style="margin-left:10px" @click="fetchData">筛选</el-button>
        <el-button size="mini" style="margin-left:10px" @click="exportCSV">导出</el-button>
      </div>

      <div class="summary">
        清运量统计：<b>{{ formatNumber(totalWeight) }}</b> kg
        清运次数统计：<b>{{ formatNumber(totalTimes) }}</b> 次
        清运支付金额：<b>{{ formatNumber(totalAmount) }}</b>
      </div>

      <div ref="chart" class="chart"></div>
    </el-card>

    <el-card class="box-card" style="margin-top: 16px;">
      <el-table ref="table" :data="tableData" height="520" border style="width: 100%;">
        <el-table-column prop="time" label="日期" :width="colWidth" />
        <el-table-column prop="times" label="清运次数(次)" :width="colWidth" />
        <el-table-column prop="weight" label="清运重量(Kg)" :width="colWidth" />
        <el-table-column prop="amount" label="清运支付金额" :width="colWidth" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getCleaningStatistics } from '@/api/statistics'

export default {
  name: 'CleaningStats',
  data() {
    return {
      preset: 'today',
      dateRange: [null, null],
      region: '',
      containerType: '',
      operator: '',
      showDetails: false,
      regionOptions: [{ label: '全部', value: '' }],
      containerOptions: [{ label: '全部', value: '' }],
      operatorOptions: [{ label: '全部', value: '' }],
      totalWeight: 0,
      totalTimes: 0,
      totalAmount: 0,
      tableData: [],
      colWidth: 200,
      chartInstance: null
    }
  },
  mounted() {
    this.initPreset()
    this.initChart()
    this.fetchData()
    this.$nextTick(() => { this.updateColWidth(); window.addEventListener('resize', this.updateColWidth) })
  },
  beforeDestroy() { window.removeEventListener('resize', this.updateColWidth) },
  methods: {
    getCompanyId() {
      const s = this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.userInfo
      const fromStore = (s && s.company_id) || ''
      const fromLocal = localStorage.getItem('company_id') || ''
      return fromStore || fromLocal || ''
    },
    formatNumber(n) {
      if (n === null || n === undefined || n === '') return '0'
      const num = Number(n)
      if (Number.isNaN(num)) return String(n)
      return String(Math.trunc(num))
    },
    formatDateTime(d, endOfDay = false) {
      const pad = n => String(n).padStart(2, '0')
      const y = d.getFullYear(), m = pad(d.getMonth() + 1), day = pad(d.getDate())
      const hh = endOfDay ? '23' : pad(d.getHours())
      const mm = endOfDay ? '59' : pad(d.getMinutes())
      const ss = endOfDay ? '59' : pad(d.getSeconds())
      return `${y}-${m}-${day} ${hh}:${mm}:${ss}`
    },
    initPreset() {
      const now = new Date()
      const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
      this.dateRange = [start, now]
    },
    setPreset(p) {
      this.preset = p
      const now = new Date()
      if (p === 'today') {
        this.dateRange = [new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0), now]
      } else if (p === 'week') {
        const day = now.getDay() || 7
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - day + 1, 0, 0, 0)
        this.dateRange = [start, now]
      } else if (p === 'month') {
        const start = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0)
        this.dateRange = [start, now]
      } else if (p === 'year') {
        const start = new Date(now.getFullYear(), 0, 1, 0, 0, 0)
        this.dateRange = [start, now]
      } else {
        this.preset = 'custom'
      }
      this.fetchData()
    },
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chart)
    },
    buildChartOption(labels, series) {
      return {
        tooltip: { trigger: 'axis' },
        grid: { left: '2%', right: '3%', top: '6%', bottom: '10%', containLabel: true },
        xAxis: { type: 'category', boundaryGap: false, data: labels },
        yAxis: { type: 'value' },
        series: [{
          type: 'line',
          smooth: true,
          lineStyle: { width: 2, color: '#f56c6c' },
          areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(245,108,108,0.35)' }, { offset: 1, color: 'rgba(245,108,108,0.0)' }]) },
          itemStyle: { color: '#f56c6c' },
          data: series
        }]
      }
    },
    updateColWidth() {
      try {
        const el = this.$refs.table && this.$refs.table.$el
        const w = (el && el.clientWidth) || 800
        const cols = 4
        const gutter = 8
        const cw = Math.floor((w - gutter) / cols)
        this.colWidth = cw
        this.$nextTick(() => { this.$refs.table && this.$refs.table.doLayout && this.$refs.table.doLayout() })
      } catch (e) {
        this.colWidth = 200
      }
    },
    escapeCSV(s) {
      const str = String(s)
      if (str.includes('"') || str.includes(',') || str.includes('\n')) {
        return '"' + str.replace(/"/g, '""') + '"'
      }
      return str
    },
    exportCSV() {
      const headers = ['日期', '清运次数(次)', '清运重量(Kg)', '清运支付金额']
      const rows = this.tableData.map(r => [r.time, r.times, r.weight, r.amount])
      const totalRow = ['合计', this.formatNumber(this.totalTimes), this.formatNumber(this.totalWeight), this.formatNumber(this.totalAmount)]
      const lines = [
        headers.join(','),
        ...rows.map(a => a.map(v => this.escapeCSV(v)).join(',')),
        totalRow.map(v => this.escapeCSV(v)).join(',')
      ]
      const bom = '\ufeff'
      const csvContent = bom + lines.join('\r\n')
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const from = this.formatDateTime(new Date(this.dateRange[0] || new Date()), false)
      const to = this.formatDateTime(new Date(this.dateRange[1] || new Date()), true)
      const filename = `清运统计_${from.replace(/[:\s]/g, '-')}_${to.replace(/[:\s]/g, '-')}.csv`
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    normalizeRow(row) {
      const d = row.date || row.time || row.hour || row.label || ''
      const time = typeof d === 'string' && d.includes(' ') ? d.split(' ')[1] : d
      const times = row.cleaning_times || row.times || row.count || 0
      const weight = row.cleaning_weight || row.weight || 0
      const amount = row.payment_amount || row.cleaning_amount || row.amount || row.money || 0
      return { time, times: Number(times) || 0, weight: Number(weight) || 0, amount: Number(amount) || 0 }
    },
    async fetchData() {
      try {
        const companyId = this.getCompanyId()
        if (!companyId) return
        const from = this.formatDateTime(new Date(this.dateRange[0] || new Date()), false)
        const to = this.formatDateTime(new Date(this.dateRange[1] || new Date()), true)
        const res = await getCleaningStatistics({ company_id: companyId, from, to })
        const body = res && res.data ? res.data : res
        const arr = Array.isArray(body.details) ? body.details : []
        const rows = arr.map(this.normalizeRow)
        this.tableData = rows
        this.totalTimes = Number(body.total_times) || rows.reduce((s, r) => s + (Number(r.times) || 0), 0)
        this.totalWeight = Number(body.total_weight) || rows.reduce((s, r) => s + (Number(r.weight) || 0), 0)
        this.totalAmount = Number(body.total_payment_amount) || rows.reduce((s, r) => s + (Number(r.amount) || 0), 0)
        const labels = rows.map(r => r.time)
        const series = rows.map(r => Math.trunc(Number(r.weight || 0)))
        const option = this.buildChartOption(labels, series)
        this.chartInstance && this.chartInstance.setOption(option)
      } catch (e) {
        const labels = []
        const series = []
        const option = this.buildChartOption(labels, series)
        this.chartInstance && this.chartInstance.setOption(option)
      }
    }
  }
}
</script>

<style scoped>
.cleaning-stats-container { padding: 20px; }
.box-card { border: none; border-radius: 8px; }
.toolbar { display: flex; align-items: center; flex-wrap: wrap; }
.summary { margin: 10px 0 6px; color: #606266; }
.summary b { color: #303133; margin: 0 4px; }
.chart { width: 100%; height: 420px; }
</style>
